import { GamePayTableProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GamePayTableProperties";
import { GameStyle } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/style/GameStyle";
import { SlingoStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/SlingoStyle";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { Point } from "pixi.js";
import { PayTableCellLandscapeProperties } from "./PayTableCellLandscapeProperties";
/**
 * PayTableLandscapeProperties.ts
 */
export class PayTableLandscapeProperties extends GamePayTableProperties {
    constructor() {
        super();
        this.animationProperties = new SpineProperties(GameStyle.PAY_LADDER, SlingoStyle.MODULE, new Point(383, 596));
        this.cells = getLandscapeCells();
        this.landscapePrimary = true;
        this.backToGameButtonProperties.visible = false;
    }
}
export function getLandscapeCells() {
    return [
        new PayTableCellLandscapeProperties(11, new Point(188, 90), new Point(175, cellY)),
        new PayTableCellLandscapeProperties(10, new Point(188, cellY), new Point(168, cellY)),
        new PayTableCellLandscapeProperties(9, new Point(174, cellY), new Point(154, cellY)),
        new PayTableCellLandscapeProperties(8, new Point(171, cellY), new Point(136, cellY)),
        new PayTableCellLandscapeProperties(7, new Point(167, cellY), new Point(133 - 8, cellY)),
        new PayTableCellLandscapeProperties(6, new Point(160, cellY), new Point(126 - 8, cellY)),
        new PayTableCellLandscapeProperties(5, new Point(156, cellY), new Point(118 - 8, cellY)),
        new PayTableCellLandscapeProperties(4, new Point(150, cellY), new Point(110 - 8, cellY)),
        new PayTableCellLandscapeProperties(3, new Point(146, cellY), new Point(100 - 8, cellY)),
        new PayTableCellLandscapeProperties(2, new Point(140, cellY), new Point(1, cellY)), //no text
        new PayTableCellLandscapeProperties(1, new Point(136, cellY), new Point(1, cellY)), //no text
    ].reverse();
}
const cellY = 64;
//# sourceMappingURL=PayTableLandscapeProperties.js.map